import { render, staticRenderFns } from "./CollectionVideoHeader.vue?vue&type=template&id=24e78b89&scoped=true&name=collection-video-header&"
import script from "./CollectionVideoHeader.vue?vue&type=script&lang=js&"
export * from "./CollectionVideoHeader.vue?vue&type=script&lang=js&"
import style0 from "./CollectionVideoHeader.vue?vue&type=style&index=0&id=24e78b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e78b89",
  null
  
)

export default component.exports